export default [
    {
        disabled: false,
        elementType: "InputWithLabel",
        htmlFor: "customer",
        label: "_customer_",
        type: "text",
        id: "customer",
        style: { add: true },
        key: ["customer", "name"],
        format: "text",
        name: "customer",
    },
    {
        disabled: false,
        elementType: "InputWithLabel",
        htmlFor: "customer",
        label: "_customer_email_",
        type: "text",
        id: "customer",
        style: { add: true },
        key: ["customer", "email"],
        format: "text",
        name: "customerEmail",
    },
    {
        disabled: false,
        elementType: "InputWithLabel",
        htmlFor: "address",
        label: "_address_label_",
        type: "text",
        id: "address",
        style: { add: true },
        key: ["receiver", "address"],
        format: "text",
        name: "address",
    },
    {
        disabled: false,
        elementType: "InputWithLabel",
        htmlFor: "additionalAddress",
        label: "_additional_address_",
        type: "text",
        id: "additionalAddress",
        style: { add: true },
        key: ["receiver", "additionalAddress"],
        format: "text",
        name: "additionalAddress",
    }, {
        disabled: true,
        elementType: "DistributorList",
        htmlFor: "distributor",
        label: "_distributor_",
        type: "text",
        id: "distributor",
        style: { add: true },
        key: "distributor",
        format: "text",
    }, {
        disabled: false,
        elementType: "InputWithLabel",
        htmlFor: "deliveryPrice",
        label: "_delivery_price_label_",
        type: "number",
        id: "deliveryPrice",
        style: { add: true },
        key: "deliveryPrice",
        format: "text",
        name: "deliveryPrice",
    }, {
        disabled: false,
        elementType: "InputWithLabel",
        htmlFor: "cacheIn",
        label: "_cache_in_",
        type: "text",
        id: "cacheIn",
        style: { add: true },
        key: "cacheIn",
        format: "text",
        name: "cacheIn",
        validations: {
            matchRegexp: /^[0-9]\d*$/,
        },
        validationErrors: {
            matchRegexp: "_negative_number_error_",
        },
    },
    {
        disabled: false,
        elementType: "InputWithLabel",
        htmlFor: "additionalCashAmount",
        label: "_additional_cash_amount_",
        type: "text",
        id: "additionalCashAmount",
        style: { add: true },
        key: "additionalCashAmount",
        format: "text",
        name: "additionalCashAmount",
        validations: {
            matchRegexp: /^[0-9]\d*$/,
        },
        validationErrors: {
            matchRegexp: "_negative_number_error_",
        },
    },{
        disabled: false,
        elementType: "RadioGroup",
        htmlFor: "radioGroup",
        label: "_radio_group_",
        type: "radioGroup",
        id: "radioGroup",
        style: { add: true },
        key: "radioGroup",
        format: "radioGroup",
    }, {
        disabled: false,
        elementType: "DateTime",
        htmlFor: "deliveryTime",
        label: "_delivery_date_time_",
        type: "text",
        id: "deliveryTime",
        style: { add: true },
        key: "deliveryTime",
        format: "text",
    }, {
        disabled: true,
        elementType: "InputWithLabel",
        htmlFor: "inPlaceTime",
        label: "_in_place_time_",
        type: "text",
        id: "inPlaceTime",
        style: { add: true },
        key: "inPlaceTime",
        format: "date",
        name: "inPlaceTime",
    }, {
        disabled: false,
        elementType: "InputWithLabel",
        htmlFor: "receiverPhone",
        label: "_receiver_phone_",
        type: "string",
        id: "receiverPhone",
        style: { add: true },
        key: ["receiver", "phone"],
        format: "text",
        name: "receiverPhone",
    }, {
        disabled: true,
        elementType: "RadioGroupNotification",
        htmlFor: "orderNotification",
        label: "_order_notifications_types_",
        type: "radioGroup",
        id: "orderNotification",
        style: { add: true },
        key: "radioGroup",
        format: "radioGroup",
    }, {
        disabled: false,
        elementType: "TextareaWithLabel",
        htmlFor: "giftCardCodes",
        label: "_gift_card_",
        type: "text",
        id: "giftCardCodes",
        style: { add: true },
        key: ["giftCardCodes"],
        format: "text",
        name: "giftCardCodes",
    },
    {
        disabled: true,
        elementType: "InputWithLabel",
        htmlFor: "giftCardAmount",
        label: "_gift_card_amount_",
        type: "number",
        id: "giftCardAmount",
        style: { add: true },
        key: ["giftCardAmount"],
        format: "number",
        name: "giftCardAmount",
    },
    {
        disabled: true,
        elementType: "InputsGroup",
        htmlFor: "recipientDetails",
        label: "_recipient_details_",
        inputs: [
            {
                disabled: true,
                type: "text",
                id: "sendToEmail",
                htmlFor: "sendToEmail",
                key: "sendToEmail",
                name: "sendToEmail",
                placeholder: "sendToEmail",
                format: "text",
                style: { add: true },
            },
            {
                disabled: true,
                type: "text",
                id: "messageToRecipient",
                htmlFor: "messageToRecipient",
                key: "messageToRecipient",
                name: "messageToRecipient",
                placeholder: "messageToRecipient",
                format: "text",
                style: { add: true },
            },
        ],
    },
    {
        disabled: true,
        elementType: "InputWithLabel",
        htmlFor: "bonusAmount",
        label: "_bonus_amount_",
        type: "number",
        id: "bonusAmount",
        style: { add: true },
        key: ["bonusAmount"],
        format: "number",
        name: "bonusAmount",
    }, {
        disabled: true,
        elementType: "InputWithLabel",
        htmlFor: "discountCode",
        label: "_discount_code_",
        type: "text",
        id: "discountCode",
        style: { add: true },
        key: "discountCode",
        format: "text",
        name: "discountCode",
    },
    {
        disabled: true,
        elementType: "InputWithLabel",
        htmlFor: "voucherInfo",
        label: "_voucher_info_",
        type: "number",
        id: "voucherInfo",
        style: { add: true },
        key: "voucherInfo",
        format: "text",
        name: "voucherInfo",
    },
    {
        disabled: true,
        elementType: "InputWithLabel",
        htmlFor: "deliveryCode",
        label: "_delivery_code_",
        type: "text",
        id: "deliveryCode",
        style: { add: true },
        key: "deliveryCode",
        format: "text",
        name: "deliveryCode",
    }, {
        disabled: false,
        elementType: "TextareaWithLabel",
        htmlFor: "comments",
        label: "_comments_label_",
        type: "text",
        id: "comments",
        style: { add: true },
        key: "comments",
        format: "text",
    }, {
        disabled: false,
        elementType: "InputWithLabel",
        htmlFor: "totalAmount",
        label: "_total_amount_",
        type: "number",
        id: "totalAmount",
        style: { add: true },
        key: "price",
        format: "text",
        name: "totalAmount",
    },

    {
        disabled: false,
        elementType: "InputWithLabel",
        htmlFor: "totalPaidAmount",
        label: "_total_paid_amount_",
        type: "number",
        id: "totalPaidAmount",
        style: { add: true },
        key: "driverExpenses",
        format: "text",
        name: "totalPaidAmount",
    }, {
        disabled: false,
        elementType: "TextareaWithLabel",
        htmlFor: "notes",
        label: "_notes_",
        type: "text",
        id: "notes",
        style: { add: true },
        key: "notes",
        format: "text",
    }, {
        disabled: false,
        elementType: "TextareaWithLabel",
        htmlFor: "hint",
        label: "_hint_",
        type: "text",
        id: "hint",
        style: { add: true },
        key: "hint",
        format: "text",
    }, {
        disabled: false,
        elementType: "CheckBox",
        htmlFor: "canReplaceProducts",
        label: "_can_replace_products_",
        type: "Checkbox",
        id: "canReplaceProducts",
        style: { add: true },
        key: "canReplaceProducts",
        format: "boolean",
    }, {
        disabled: false,
        elementType: "TextareaWithLabel",
        htmlFor: "distributorRejectionReasons",
        label: "_distributor_rejection_reasons_",
        type: "text",
        id: "distributorRejectionReasons",
        style: { add: true },
        key: "distributorRejectionReasons",
        format: "text",
    }, {
        disabled: false,
        elementType: "InputWithLabel",
        htmlFor: "imTaxCode",
        label: "_taxpayer_identification_number_",
        type: "text",
        id: "imTaxCode",
        style: { add: true },
        key: ["imTaxCode"],
        format: "text",
        name: "imTaxCode",
    }];
